import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="turbo-form"
export default class extends Controller {
  static targets = ["form"];

  connect() {
    // Initialize controller
  }

  // Submit the form when an input changes
  submit(event) {
    // Prevent default only if this is a click event
    if (event.type === "click") {
      event.preventDefault();
    }

    // Submit the form
    if (this.hasFormTarget) {
      this.formTarget.requestSubmit();
    } else if (event.target.form) {
      event.target.form.requestSubmit();
    }
  }
}
